"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeolocationController = void 0;
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const streem_error_1 = require("../../streem_error");
const logger_1 = require("../../util/logger");
const utils_1 = require("../wall/utils");
const last_created_at_1 = require("../../util/rx/last_created_at");
class GeolocationController {
    constructor(config) {
        this.config = config;
        this.requests = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifactRequest'), (0, utils_1.accumulateAndMapWallEvents)('artifactRequest'), (0, operators_1.shareReplay)(1));
        this.responses = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndMapWallEvents)('artifact'), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.GPS_POSITION), (0, operators_1.shareReplay)(1));
        this.latestLocation = this.responses.pipe((0, utils_1.excludeByProperty)('gpsPosition', undefined), (0, last_created_at_1.lastCreatedAt)());
    }
    /**
     * Adds a geolocation request to the wall
     */
    requestGeolocation() {
        if (!this.config.context.remoteUserId || !this.config.context.remoteDeviceId) {
            const msg = 'remoteUserId and removeDeviceId are rewired for streemshot request';
            logger_1.logger.error(msg);
            throw new streem_error_1.StreemError(msg);
        }
        const artifactId = this.config.roomWall.addGeolocationRequest(this.config.context.remoteUserId, this.config.context.remoteDeviceId);
        logger_1.logger.info(`Requesting geolocation from remoteUserId ${this.config.context.remoteUserId} on device ${this.config.context.remoteDeviceId}: `, artifactId);
        return artifactId;
    }
    /**
     * Adds a fulfilled geolocation to the wall
     */
    fulfillGeolocation(gpsId, gpsRequestId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('geolocation' in navigator)) {
                this.errorGeolocation(gpsId, gpsRequestId);
            }
            navigator.geolocation.getCurrentPosition((position) => __awaiter(this, void 0, void 0, function* () {
                let formattedAddress;
                try {
                    formattedAddress = yield this.reverseGeocode(position.coords.latitude, position.coords.longitude);
                }
                catch (error) {
                    logger_1.logger.error('failed to reverse geocode coordinates', error);
                    this.errorGeolocation(gpsId, gpsRequestId);
                    return;
                }
                this.addGpsResponse(gpsId, gpsRequestId, 'FULFILLED', position, formattedAddress);
            }), err => {
                const permissionDeniedCode = 1;
                if (err.code === permissionDeniedCode) {
                    this.rejectGeolocation(gpsId, gpsRequestId);
                }
                else {
                    this.errorGeolocation(gpsId, gpsRequestId);
                }
            }, { enableHighAccuracy: true });
        });
    }
    errorGeolocation(gpsId, gpsRequestId) {
        this.addGpsResponse(gpsId, gpsRequestId, 'ERROR');
    }
    rejectGeolocation(gpsId, gpsRequestId) {
        this.addGpsResponse(gpsId, gpsRequestId, 'REJECTED');
    }
    addGpsResponse(gpsId, gpsRequestId, status, position, formattedAddress) {
        const gpsPosition = status === 'FULFILLED' && position
            ? {
                accuracy: position.coords.accuracy,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                formattedAddress: formattedAddress,
            }
            : undefined;
        const response = this.config.roomWall.addGeolocationResponse(gpsId, {
            inResponseToWallItemId: gpsRequestId,
            artifactType: streem_sdk_protobuf_1.WallItem.ArtifactType.GPS_POSITION,
            gpsPosition: gpsPosition,
            status: streem_sdk_protobuf_1.WallItem.Artifact.Status[status],
        });
        // @TODO Enable this with upcoming analytics work for CV2.
        // recordArtifactCaptured(response);
        logger_1.logger.info(`added geolocation response ${response} to wall`);
    }
    reverseGeocode(lat, lng) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (GeolocationController.GoogleMapsKey === undefined) {
                throw new Error('Google Maps API key missing');
            }
            const query = new URLSearchParams();
            query.set('latlng', `${lat},${lng}`);
            query.set('key', GeolocationController.GoogleMapsKey);
            const url = `https://maps.googleapis.com/maps/api/geocode/json?` + query.toString();
            const res = yield fetch(url);
            if (res.status === 200) {
                const payload = yield res.json();
                if (payload.results.length) {
                    return payload.results[0].formatted_address;
                }
                else {
                    throw new Error('Could not find a formatted address in reverse geocode response');
                }
            }
            else {
                const body = yield res.json();
                const message = (_a = body.message) !== null && _a !== void 0 ? _a : 'APIError: ';
                throw new Error(message);
            }
        });
    }
}
exports.GeolocationController = GeolocationController;
//# sourceMappingURL=geolocation_controller.js.map